import colors from './colors';
import components from './components';
import styles from './styles';
import breakpoints from './breakpoints';
import fontSizes from './fontSizes';
import { textStyles, fontWeight } from '../chakra/typography';
import semanticTokens from './semanticTokens';

export default {
  breakpoints,
  colors,
  components,
  styles,
  fontSizes,
  semanticTokens,
  textStyles,
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: fontWeight.bold,
    emphasized: fontWeight.emphasized,
    button: fontWeight.button,
  },
};
